import React, { FunctionComponent } from 'react'
import dynamic from 'next/dynamic'
import ErrorBoundary from '@dustin-web/microsite-components/src/utils/error-boundary'
import { DevUtils } from '@dustin-web/microsite-components/src/dev/dev-admin'
import { BaseLayoutInputPageConfig } from '@dustin-web/microsite-config/src'

const BaseLayout = dynamic(() => import('./base-layout'))

type Props = {
  showHeader: boolean
  devUtils: DevUtils
  page?: BaseLayoutInputPageConfig
  children?: React.ReactNode
}

const BaseLayoutSwitcher: FunctionComponent<Props> = ({ page, devUtils, showHeader, children }) => {
  if (showHeader) {
    return (
      <ErrorBoundary>
        <BaseLayout page={page} devUtils={devUtils}>
          {children}
        </BaseLayout>
      </ErrorBoundary>
    )
  }

  return <>{children}</>
}

export default BaseLayoutSwitcher
